/**
 * Country options for workspace configuration
 */
export const countryOptions = [
  { label: 'Singapore', value: 'sg' },
  { label: 'Malaysia', value: 'my' },
  { label: 'Indonesia', value: 'id' }
  // { label: 'Thailand', value: 'th' },
  // { label: 'Philippines', value: 'ph' },
  // { label: 'Vietnam', value: 'vn' },
  // { label: 'United States', value: 'us' },
  // { label: 'United Kingdom', value: 'gb' },
  // { label: 'Australia', value: 'au' },
  // { label: 'New Zealand', value: 'nz' },
  // { label: 'Hong Kong', value: 'hk' },
  // { label: 'Taiwan', value: 'tw' },
  // { label: 'Japan', value: 'jp' },
  // { label: 'South Korea', value: 'kr' },
  // { label: 'China', value: 'cn' },
  // { label: 'India', value: 'in' }
]

/**
 * Timezone options for workspace configuration
 */
export const timezoneOptions = [
  { label: 'Asia/Singapore', value: 'Asia/Singapore' },
  { label: 'Asia/Kuala_Lumpur', value: 'Asia/Kuala_Lumpur' },
  { label: 'Asia/Jakarta', value: 'Asia/Jakarta' },
  { label: 'Asia/Makassar', value: 'Asia/Makassar' },
  { label: 'Asia/Jayapura', value: 'Asia/Jayapura' }
  // { label: 'Asia/Bangkok', value: 'Asia/Bangkok' },
  // { label: 'Asia/Manila', value: 'Asia/Manila' },
  // { label: 'Asia/Ho_Chi_Minh', value: 'Asia/Ho_Chi_Minh' },
  // { label: 'America/New_York', value: 'America/New_York' },
  // { label: 'America/Los_Angeles', value: 'America/Los_Angeles' },
  // { label: 'Europe/London', value: 'Europe/London' },
  // { label: 'Australia/Sydney', value: 'Australia/Sydney' },
  // { label: 'Pacific/Auckland', value: 'Pacific/Auckland' },
  // { label: 'Asia/Hong_Kong', value: 'Asia/Hong_Kong' },
  // { label: 'Asia/Taipei', value: 'Asia/Taipei' },
  // { label: 'Asia/Tokyo', value: 'Asia/Tokyo' },
  // { label: 'Asia/Seoul', value: 'Asia/Seoul' },
  // { label: 'Asia/Shanghai', value: 'Asia/Shanghai' },
  // { label: 'Asia/Kolkata', value: 'Asia/Kolkata' }
]

/**
 * Fallback database group code options if API fails
 */
export const fallbackDatabaseGroupOptions = [{ label: 'public', value: 'public' }]

/**
 * Restore template options for workspace creation
 */
export const restoreTemplateOptions = [
  { label: 'None', value: null },
  { label: 'Demo Template', value: 'zea02' },
  { label: 'Minimal Template', value: 'zea03' }
]

/**
 * Workspace type options for request form
 */
export const workspaceTypeOptions = [
  { label: 'New workspace',   value: 'new' },
  { label: 'Demo workspace',  value: 'demo' },
  { label: 'Trial workspace', value: 'trial' },
  { label: 'UAT workspace',   value: 'uat' },
]
